export const isValidCoordinate = (lat: any, lng: any): boolean => {
    return lat != null && 
           lng != null ;
  }

export const  ATTENDANCE_ACTIONS = {
    SIGNIN: {
      successText: 'Signed In',
      errorText: 'Signing In',
      isSignedOff: false
    },
    SIGNOUT: {
      successText: 'Signed Out',
      errorText: 'Signing Out',
      isSignedOff: true
    }
  };

  export enum AttendanceAction {
    SIGNIN = 'SIGNIN',
    SIGNOUT = 'SIGNOUT'
  }
  